import * as React from "react";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@emotion/react";
import { useDispatch, useSelector } from "react-redux";

import {
  setAlertDialog,
  setAlertDialogData,
} from "../../../redux/features/settingSlice";
import { getSettingState } from "../../../redux/features/settingSlice";
import CustomButton from "../CustomButton/index";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

export default function AlertDialog() {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { alertDialog, alertDialogData } = useSelector(getSettingState);

  const handleClose = () => {
    dispatch(setAlertDialog(false));
    dispatch(setAlertDialogData(null));
  };

  const handleBtn1Action = () => {
    handleClose();
    alertDialogData?.btn1Onclick();
  };

  const handleBtn2Action = () => {
    handleClose();
    alertDialogData?.btn2Onclick();
  };

  return (
    <Box sx={{ position: "absolute", zIndex: 9 }}>
      <Dialog
        sx={{
          "& .MuiPaper-elevation": {
            width: "400px",
            borderRadius: "16px",
            border: "2px solid",
            borderColor: "black.main",
            boxShadow: `0px 4px 0px ${theme.palette.black.main}`,
          },
        }}
        open={alertDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby='login-dialog'
      >
        <Box sx={{ padding: "24px" }}>
          <Typography
            sx={{
              fontSize: "24px",
              fontWeight: 600,
              lineHeight: "32px",
              mb: "8px",
            }}
          >
            {alertDialogData?.title}
          </Typography>
          <Typography
            sx={{
              fontSize: "16px",
              lineHeight: "24px",
              mb: "24px",
            }}
          >
            {alertDialogData?.dis}
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "end" }}>
            <CustomButton
              title={alertDialogData?.btn1 || "Cancel"}
              onClick={
                alertDialogData?.btn1Onclick ? handleBtn1Action : handleClose
              }
              fSize='16px'
              width='auto'
              height='40px'
              bShadow={alertDialogData?.btn1Color === "primary" ? "4px" : "0px"}
              bgColor={
                (alertDialogData?.btn1Color
                  ? alertDialogData?.btn1Color
                  : "white") + ".main"
              }
              mRight='10px'
            />
            <CustomButton
              title={alertDialogData?.btn2 || "Login"}
              onClick={
                alertDialogData?.btn2Onclick ? handleBtn2Action : handleClose
              }
              fSize='16px'
              width='auto'
              height='40px'
              bShadow={alertDialogData?.btn2Color === "primary" ? "4px" : "0px"}
              bgColor={
                (alertDialogData?.btn2Color
                  ? alertDialogData?.btn2Color
                  : "primary") + ".main"
              }
            />
          </Box>
        </Box>
      </Dialog>
    </Box>
  );
}
